import React, { useEffect, useContext } from "react";
import { Form, Field } from "react-final-form";
import { QuestionContext } from "../../../Utils/contexts/QuestionContext";
import { ModalInput } from "../../General/ModalInput/ModalInput";
import ModalButton from "../../General/ModalButton/ModalButton";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SequenceItem from "../SequenceItem/SequenceItem";
import { LANGUAGE } from "../../../Utils/language";
import AnswerOptionInputFields from "./AnswerOptionInputFields";
import "./TESTFORM.css";

const CreateQuestionForm = (props) => {
  const { traits, setSequence, sequence, setLanguage, language } = useContext(
    QuestionContext
  );

  const scoreInput = (score, index) => {
    return {
      header: `Points ${index + 1}`,
      id: `Points ${index + 1}`,
      divName: "ScoreInput",
      initialValue: score,
      type: "text",
      labelName: "Text-left",
      style: {
        display: "flex",
        flexDirection: "column",
        marginRight: "10px",
        width: "100%",
      },
    };
  };
  const scorePlaceHolder = [0, 0, 0, 0, 0];
  const questionFormulationInput = {
    header: language === "EN" ? "Question " : "Fråga ",
    id: language === "EN" ? "Question " : "Fråga ",
    divName: "Question-formulation-input",
    type: "text",
    labelName: "Text-left",
    style: { display: "flex", flexDirection: "column", marginBottom: "10px" },
  };

  const onDragEnd = ({ destination, source }) => {
    if (destination === null) return;
    if (!destination.droppableId.includes("orderList")) {
      return;
    }
    const newSequence = sequence.slice();
    const tmp = sequence[source.index];
    newSequence[source.index] = newSequence[destination.index];
    newSequence[destination.index] = tmp;
    setSequence(newSequence);
  };
  const init = {
    Traits: traits[0].id,
  };
  useEffect(() => {
    const languageDropdown = document.getElementById("LanguageDropdown");
    const traitDropDown = document.getElementById("Traits");
    languageDropdown.value = (language);
    M.FormSelect.init(languageDropdown);
    M.FormSelect.init(traitDropDown);
  }, [sequence]);
  return (
    <Form
      id="questionUpdateForm"
      onSubmit={props.onSubmit}
      initialValues={init}
      keepDirtyOnReinitialize={false}
      render={({ handleSubmit, submitting, form }) => (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5
              className="modal-title"
              style={{ textAlign: "left" }}
              id={props.modalHTMLIdentifier + "modalHeader"}
            >
              {"Skapa fråga"}
            </h5>
            <div
            >
              <i className="material-icons modal-close Close-cross-button" onClick={() => {
                form.reset();
                props.onCancel && props.onCancel();
              }}>close</i>
            </div>
          </div>
          <form onSubmit={(values) => handleSubmit(values, form)}>
            <div className="Input-container">
              <div className="Input-column">
                <div className="Flex-column Modal-input">
                  <label style={{ textAlign: "left" }}>Kategori</label>
                  <Field
                    id={"Traits"}
                    name={"Traits"}
                    aria-label="modal-input"
                    component={"select"}
                    className={"Drop-down-selector Language hideSelector"}
                  >
                    {traits.map((trait) => {
                      return (
                        <option value={trait.id} key={trait.id}>
                          {`${trait.symbol}: ${
                            trait.name.find(
                              (translation) => translation.language === language
                            ).value
                          }`}
                        </option>
                      );
                    })}
                  </Field>
                </div>
                <div className="Flex-column Modal-input2">
                  <label>Språk</label>
                  <select
                    id="LanguageDropdown"
                    className="Drop-down-selector Language hideSelector"
                    onChange={(e) => setLanguage(e.target.value)}
                  >
                    <option value={LANGUAGE.SWEDISH}>Svenska</option>
                    <option value={LANGUAGE.ENGLISH}>English</option>
                  </select>
                </div>
              </div>
              <Field
                name={questionFormulationInput.header}
              >
                {({ input, meta }) => (
                  <ModalInput
                    inputField={questionFormulationInput}
                    labelName="input-label"
                    input={input}
                    meta={meta}
                  />
                )}
              </Field>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ width: "95%" }}></div>
                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "#9e9e9e",
                    textAlign: "left",
                    minWidth: "5%",
                  }}
                >
                  Svarsordning
                </p>
              </div>
              <div className="AnswerOptionContainer">
                <div className="Scores">
                  {scorePlaceHolder.map((score, index) => {
                    const inputFieldScore = scoreInput(score, index);
                    return (
                      <div
                        className="Input-column"
                        key={`createQuestionScoreInput${index}`}
                      >
                        <Field
                          name={inputFieldScore.header}
                          key={`createQuestionScoreInput${index}`}
                        >
                          {({ input, meta }) => (
                            <ModalInput
                              input={input}
                              meta={meta}
                              labelName="input-label"
                              inputField={inputFieldScore}
                            />
                          )}
                        </Field>
                      </div>
                    );
                  })}
                </div>
                <div className="Answers">{<AnswerOptionInputFields />}</div>
                <div className="Order">
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable
                      droppableId="orderList"
                      type="question"
                      style={{ height: "100%" }}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          className="Q-Report-form-dnd"
                          style={{
                            backgroundColor: snapshot.isDraggingOver
                              ? "grey"
                              : "rgb(217, 217, 217)",
                            overflow: "hidden",
                          }}
                          {...provided.droppableProps}
                        >
                          <div>
                            <div>
                              {sequence.map((sequencePosition, index) => {
                                return (
                                  <Draggable
                                    draggableId={`draggable-${sequencePosition}`}
                                    key={sequencePosition}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <SequenceItem
                                          sequencePosition={sequencePosition}
                                          key={index}
                                        />
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })}
                            </div>
                            {provided.placeholder}
                          </div>
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
            {props.inputFields.map((inputField, key) => (
              <Field
                name={inputField.header}
                key={key}
              >
                {({ input, meta }) => (
                  <ModalInput
                    labelName="input-label"
                    input={input}
                    inputField={inputField}
                    meta={meta}
                  />
                )}
              </Field>
            ))}
            <div>{props.bodyText}</div>
            <div className="modal-footer border-top-0 Footer-container">
              <ModalButton
                buttonName={props.cancelButtonName}
                buttonType={"button"}
                disabled={submitting}
                onCancel={form.reset}
                buttonTrigger="modal-close"
              />
              <ModalButton
                buttonName={props.submitButtonName}
                buttonType={"submit"}
                disabled={submitting}
                buttonTrigger=""
              />
            </div>
          </form>
        </>
      )}
    />
  );
};

export default CreateQuestionForm;
